'use strict';

/* Views */
import NewsArchive from './archive/news-archive.component';
import NewsEdit from './edit/news-edit.component';
import NewsList from './list/news-list.component';
import NewsView from './show/news-show.component';

/* Components */
import NewsPostComponent from '../../components/news/post/NewsPost.component';

/* Services */
import NewsService from '../../services/news/news.service';

export default angular.module('conduuApp.news', [NewsArchive, NewsEdit, NewsList, NewsView, NewsPostComponent, NewsService])
  .name;



// WEBPACK FOOTER //
// ./client/app/news/index.js